module.exports = __webpack_public_path__ + "img/dreiecke-gray-klein.c0f0dcf.png";